class TraceForm extends HTMLElement {
  constructor() {
    super();
    //Form elements
    this.traceForm = this;
    this.formData = JSON.parse(this.dataset.formData)
    this.form = this.querySelector('[data-form]');
    this.input = this.querySelector('input');
    this.error = this.querySelector('[data-form-error]');

    this.input.addEventListener('input', () => {
      this.error.classList.add('hidden');
    });

    this.submitButton = this.querySelector('[data-submit-button]');
    this.submitButton.addEventListener('click', this.onSubmit.bind(this));

    //Success elements
    this.successElm = this.querySelector('[data-form-success]');
    this.lotProductElms = this.successElm.querySelectorAll('[data-lot-product]');
    this.lotNumberElms = this.successElm.querySelectorAll('[data-lot-number]');
    this.expirationDateElms = this.successElm.querySelectorAll('[data-expiration-date]');

    this.lotNumberPageButton = this.querySelector('[data-lot-number-page-button]');

    this.resetButton = this.querySelector('[data-form-reset]');
    this.resetButton.addEventListener('click', this.onReset.bind(this));

    window.addEventListener('shopify:section:load', (event) => {
      this.successElm.classList.remove('hidden');
      this.input.value = '123456789';
      this.lotNumberElms.forEach((lotElm) => {
        lotElm.textContent = '123456789';
      });

      this.expirationDateElms.forEach((dateElm) => {
        dateElm.textContent = ' 2025-01-24';
      });
    });

  }

  onSubmit() {
    let hasSame = false;
    let inputValue = this.input.value;

    if (!this.formData) { return false; }

    this.formData.forEach((data) => {
      if (data.lot_number === inputValue) {
        hasSame = true;

        //Fill right data
        if (this.lotProductElms && data.product !== undefined && data.product !== null) {
          this.lotProductElms.forEach((lotProductElm) => {
            lotProductElm.textContent = data.product;
          });
        }

        this.lotNumberElms.forEach((lotElm) => {
          lotElm.textContent = data.lot_number;
        });

        this.expirationDateElms.forEach((dateElm) => {
          dateElm.textContent = data.expiration_date;
        });


        if (this.lotNumberPageButton) {
          if (data.page_link) {
            this.lotNumberPageButton.href = data.page_link;
          } else {
            this.lotNumberPageButton.classList.add('hidden');
          }
        }

        // Show data & hide form
        this.successElm.classList.remove('hidden');
        this.form.classList.add('hidden');
        this.error.classList.add('hidden');
        return;
      }
    });


    if (hasSame === false) {
      //No data found
      this.error.classList.remove('hidden');
      this.successElm.classList.add('hidden');
      this.form.classList.remove('hidden');
    }
  }

  onReset() {
    this.successElm.classList.add('hidden');
    this.error.classList.add('hidden');
    this.form.classList.remove('hidden');
    this.input.value = '';
    const yOffset = -120;
    const scrollTo = this.traceForm.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({top: scrollTo, behavior: 'smooth'});
  }
}

// Define the custom element
if (!customElements.get('trace-form')) {
  customElements.define('trace-form', TraceForm);
}